
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqFf7bHteTsLqx6eXuCVW1Jvyx_45oUo0_yaIHyA3MaSYoUMeta } from "/codebuild/output/src3903864779/src/src/pages/faq.vue?macro=true";
import { default as menu0HXYrwRNCcYFgpWKjgHpxhxEOS9BNKFFHWBC1A1PFEEMeta } from "/codebuild/output/src3903864779/src/src/pages/menu.vue?macro=true";
import { default as index_45dbdoJwOaCvntD6UrzQl3nkWjl2_6sxLlT_MbnheJ5EMeta } from "/codebuild/output/src3903864779/src/src/pages/index.vue?macro=true";
import { default as contactY56aL4QGYKlsIAh6UPEDowlUNcuHohFaqTEEDjw08RoMeta } from "/codebuild/output/src3903864779/src/src/pages/contact.vue?macro=true";
import { default as tutoriale75i7y3ci1N07ePr4qe9_xLgNGIBu6VdkDjExWfY_45mMMeta } from "/codebuild/output/src3903864779/src/src/pages/tutorial.vue?macro=true";
import { default as agreementU2IgFV_5Us7IRHeEwL2GFNq_45xxSxtUn6suC4MipE82sMeta } from "/codebuild/output/src3903864779/src/src/pages/agreement.vue?macro=true";
import { default as about_45passDm4tVyR_45DcEmFA2by7bE9SuvoqUM9kjn15b7jSi87T4Meta } from "/codebuild/output/src3903864779/src/src/pages/about-pass.vue?macro=true";
import { default as indexW9edxEYYnPaHdLOqy4h31dfIarNsUpTBlDEBNS2_A3QMeta } from "/codebuild/output/src3903864779/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93MNkYuz9lvyQErFXFLOQ7PXfYAxq8LrZSpkDOlW9kunkMeta } from "/codebuild/output/src3903864779/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance_fY5tEgyAAPzBZtyRTAQ48mjI26tRNEIGwnL4D5Y5cAMeta } from "/codebuild/output/src3903864779/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93OiuDBYn7zlrzYaJQlWgme1GDBX5gcqrokXNoigsFZHAMeta } from "/codebuild/output/src3903864779/src/src/pages/notice/[id].vue?macro=true";
import { default as indextd_45D3u0ttu9zzlAY6RicPuFMRprUVGLn7wUkrm2VKKgMeta } from "/codebuild/output/src3903864779/src/src/pages/coupon/index.vue?macro=true";
import { default as index_45u3G3AlZ9Rq8dfjRAI5CsdiD2ig4dJ1koAVi5PvPDrsMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/index.vue?macro=true";
import { default as indexZ3ET3IXPa7veGmbA9Yt5CrtXDRYZrG2DTV8fVc1Y_R8Meta } from "/codebuild/output/src3903864779/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93tGy1vdeECY4HDpAERg5CKJii4PPky3VKtPvH_45demP3UMeta } from "/codebuild/output/src3903864779/src/src/pages/parking/[id].vue?macro=true";
import { default as indexU_45_45wfjbjG7MMJvKHGGGGKwIomLCGCJYZffMOVDF6Xl8Meta } from "/codebuild/output/src3903864779/src/src/pages/history/index.vue?macro=true";
import { default as index6qedLJQ8oqT5xaS4A8pX9obM1WR0wkoaqYXCDySuLFoMeta } from "/codebuild/output/src3903864779/src/src/pages/monthly/index.vue?macro=true";
import { default as indexMGfUEX9hQzHGlM8j7A67PjKlhT4fn2MavFHor_NIM4cMeta } from "/codebuild/output/src3903864779/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexMtyUORIkzWgPRiC3TZL6uA8rfnBay1lnO_45nV9_45GF91kMeta } from "/codebuild/output/src3903864779/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavioUldSlFkiBvi9Gqzf8t1O_45ow_ruDbLHkjoTQ99qHZ6wMeta } from "/codebuild/output/src3903864779/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editN_45qae0sygwndy8ITJPDelHvJqPGtlikymx8gq9lPMx0Meta } from "/codebuild/output/src3903864779/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement77yNTKSuZk1LJZq7bdrzokzkfmAXLrE_8aU8qw_laFcMeta } from "/codebuild/output/src3903864779/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexA7w9_01ytxtImvC2N8Shuq884KDpBI66PKpPkBBnX7AMeta } from "/codebuild/output/src3903864779/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dJk5j0tx9P6We34kfiofnSsKHsMdUTG0ra21Rv_45pD67sMeta } from "/codebuild/output/src3903864779/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmCx6o2lQ0uNtX_456w4CtXltqKE_45bACgn9w1urkMGokyKQMeta } from "/codebuild/output/src3903864779/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexXyavyl8yeKY1ujX1JnemY6w7p9y2texnvsFM94hzeQMMeta } from "/codebuild/output/src3903864779/src/src/pages/card/create/index.vue?macro=true";
import { default as indexMQ8yZwcFYqPrqSate6f_7fo5QY7EP_A3fgXUl66CXk4Meta } from "/codebuild/output/src3903864779/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm21bJaszPWet3qVjqxsg7iJJIkfzS2JN5fyIeGDdHXmsMeta } from "/codebuild/output/src3903864779/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmkl1dYLP8skP_45oVMjY8CESnakYa0DaagZCw87S2UHfq0Meta } from "/codebuild/output/src3903864779/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete1gBDJelboalBqqqxv9i_j4_45ZgWM4SKcUhT_h4NJsplgMeta } from "/codebuild/output/src3903864779/src/src/pages/membership/complete.vue?macro=true";
import { default as registerUGZ2BMDlEAqFftcZgU85sxXCgslrrvIODtnn1K1urT4Meta } from "/codebuild/output/src3903864779/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93MWAi2Rl6_EN4ph2xXDQ4Lwe226rhIlhLoBj6nGrJ2YUMeta } from "/codebuild/output/src3903864779/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmgcr8JLHB82bQXbFmq2fo2uDQ7P8UIK5EBTJCbKw9WlAMeta } from "/codebuild/output/src3903864779/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93C14xy_459Lf1s91br9_45o_455QxZ76WwxZCRgDy2gsFij210Meta } from "/codebuild/output/src3903864779/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexv7quyPKSkfO_JIYOVVWk_s692EsbdL8Q9T6M0cuDXz8Meta } from "/codebuild/output/src3903864779/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codevfNkSoV0_45H9pYSP6fK_45hmZZdnphjDVP1rT0NtJsg9YkMeta } from "/codebuild/output/src3903864779/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeYFRZPAJ_kDFyzCw8KO2qdFZLvWdFu_45WpFK_QDRllJRAMeta } from "/codebuild/output/src3903864779/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeSEb2eo32T6paASSyjCuIIlK90MlLVus8PkYdtW7GVxEMeta } from "/codebuild/output/src3903864779/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerEBaP5gdQIAme_wA6SsFGd0NPCKG0wBSQz6TKWIVAbw8Meta } from "/codebuild/output/src3903864779/src/src/pages/contact-form/register.vue?macro=true";
import { default as completebNtrj4TfNZhUWpZSuJ9APTvvz6j24UM9M5JOEVA_7VQMeta } from "/codebuild/output/src3903864779/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexlrU1vgqQT7WPptfVojnP1fXiDHx0b6DBmeGtUcPlK6cMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm_45sh6QgYEJ9VUOmZT1LCPfjdnrukCX2kWhzZjT_45FBLrEMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as complete0bho1qZ2NBqvw2KVwwGNdCvmJ3fJ4wA9rGyZ3D_45wYyMMeta } from "/codebuild/output/src3903864779/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexRiQ6QAOu4_xKoFgXGB1GwC9HK7nqnPPiBCb8JaUpS_EMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93NTWHdozoFfEO3YnWVhBe50MJciSEnmzU_45Z1lkaVQieUMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completevV40FU2zRERwtZPMrBy5HSWShVKwBXGykDta93lRBr8Meta } from "/codebuild/output/src3903864779/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasRUDZO5zPEABHZoskfTmdR2xfitAxkEYxCsFPaNhe8FgMeta } from "/codebuild/output/src3903864779/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleI1BaFalATOLGsLIK1xXngs_eP5wK2cxuh1roprGU7IMMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailKxHGXm4a176_45GD5gqvGeQCRcgL0cdLu1O16nj7nbeD8Meta } from "/codebuild/output/src3903864779/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm_yzHlW9vReWQnjwM3sYYCmp37LBIH_k2Whvvjh0KQzsMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentwTYTStUSxbidsAnKZX1j_45ZB8MwEj4MQnZvuL08UZl8QMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmjD90aS_451yMBf0vYdykfhzx3Csa_9okyxhkcAtQ7_bDUMeta } from "/codebuild/output/src3903864779/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateidkRewsNKPShG7kzUiDISSS39YADBZwr_3z1DJ_45H5tYMeta } from "/codebuild/output/src3903864779/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeyzCVSP3CvxGfORP76Xpp2G2Wk3nphhY135Of0nU_AH4Meta } from "/codebuild/output/src3903864779/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeGOdRfjxnA6RlvWm80HL9IaVNMdabeTVyzLHUc0G_451gcMeta } from "/codebuild/output/src3903864779/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordr3z6ZMXrz70Jjc1BXy1e6aOsVYn01HMrR4V_45z3BMUwUMeta } from "/codebuild/output/src3903864779/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45alias3l2xgy8V1sLDTsd7ebyPdvrua2adhkE66mbeCZ7zXEIMeta } from "/codebuild/output/src3903864779/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerL5sPfx1kRRkahxncS4HADtSWUw1vGcrUXpRmIfgBGbIMeta } from "/codebuild/output/src3903864779/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45code4LWNvVaOG3faYr_r6Yd_45s47uFpAEpMIupxUXCSNok_QMeta } from "/codebuild/output/src3903864779/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexjnFvTR_vuq40rJc4B0WuegzPGX32bND8yw2YpkpjJusMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexJ827w3ZlUmfx7lC35NPSCfOMyy_45AfVpaCq2AgRy2ftgMeta } from "/codebuild/output/src3903864779/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as index6ZYsQnaIIxR3WycWS86_HLNj09T1TnQg1oOz6CxyCGgMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexo6hrcytTjukUwIVr31ozHOH_458PXDkbf3nRxkko32Z3QMeta } from "/codebuild/output/src3903864779/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateiUN8id7im7bMt4jvSIDJGYK2K4NMVY4YxSlxaA_R4WsMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completenbXEwApfLvS7UYeu9H6y1B6FcUhwOnypA1vfdGw2CzMMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmfyqDJ7FSWYbAdzL7mI1KFw_45YOW2BDk6FqRsiT1086fsMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexEfZKggGZvT6gn3PWO3_f0LbQRWGWYnge_45RVIsec4hWYMeta } from "/codebuild/output/src3903864779/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeQ2vvaPekDRBY9_syQAMlaI_oVkZUMWS4UBdWMZ_45v2eUMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update84v2_45k3doDd8faeqkw2Yfm0yf2Gg6WT3IlbmR3nI4bUMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexKiyxWCmWChYM20ilFVVZJ63fjtf3ZnNJO8WUL_3vdpYMeta } from "/codebuild/output/src3903864779/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index5z9xfZ9iAyOdkGx2g0BXIpmg3txuoe39Iarw4utRg98Meta } from "/codebuild/output/src3903864779/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeoMHTwNDxInIGq3cDOSXgHbglvOaTPpG7q2gL8RCeWfwMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexlZET_OQFVnVEoIcOBOHEyeyGZGRcsEfKiQ5EegP4fSUMeta } from "/codebuild/output/src3903864779/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeOV_45fa7K2yK56hj45JR3bYNaGPiuHiW8kFwRTu2kbi4oMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexwGsE812vVgMPgwKCCND_mm2d9q3_45xRHe4TB4A8VyRLsMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index_rzuofIWhGPRMz12uZuIpPa1yROPsoS0ozz5_BNkRZoMeta } from "/codebuild/output/src3903864779/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexQUeRTOiWbIaRYDM45xNJog9j0ZHBCtFcd7V7TqD8sC8Meta } from "/codebuild/output/src3903864779/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update6AbzcszCeaCVFaMW6DqBfE0uDtNDZijcyG8Z53tE25EMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmterzlylxvs_45Rtht2dfoHrPPAFfj4Z6s_45BjSDWxB84TYMeta } from "/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu0HXYrwRNCcYFgpWKjgHpxhxEOS9BNKFFHWBC1A1PFEEMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index_45dbdoJwOaCvntD6UrzQl3nkWjl2_6sxLlT_MbnheJ5EMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indextd_45D3u0ttu9zzlAY6RicPuFMRprUVGLn7wUkrm2VKKgMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3903864779/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexU_45_45wfjbjG7MMJvKHGGGGKwIomLCGCJYZffMOVDF6Xl8Meta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3903864779/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexMGfUEX9hQzHGlM8j7A67PjKlhT4fn2MavFHor_NIM4cMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexMtyUORIkzWgPRiC3TZL6uA8rfnBay1lnO_45nV9_45GF91kMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexXyavyl8yeKY1ujX1JnemY6w7p9y2texnvsFM94hzeQMMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm21bJaszPWet3qVjqxsg7iJJIkfzS2JN5fyIeGDdHXmsMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmkl1dYLP8skP_45oVMjY8CESnakYa0DaagZCw87S2UHfq0Meta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3903864779/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete1gBDJelboalBqqqxv9i_j4_45ZgWM4SKcUhT_h4NJsplgMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerUGZ2BMDlEAqFftcZgU85sxXCgslrrvIODtnn1K1urT4Meta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmgcr8JLHB82bQXbFmq2fo2uDQ7P8UIK5EBTJCbKw9WlAMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codevfNkSoV0_45H9pYSP6fK_45hmZZdnphjDVP1rT0NtJsg9YkMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeYFRZPAJ_kDFyzCw8KO2qdFZLvWdFu_45WpFK_QDRllJRAMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeSEb2eo32T6paASSyjCuIIlK90MlLVus8PkYdtW7GVxEMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerEBaP5gdQIAme_wA6SsFGd0NPCKG0wBSQz6TKWIVAbw8Meta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm_45sh6QgYEJ9VUOmZT1LCPfjdnrukCX2kWhzZjT_45FBLrEMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: complete0bho1qZ2NBqvw2KVwwGNdCvmJ3fJ4wA9rGyZ3D_45wYyMMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexRiQ6QAOu4_xKoFgXGB1GwC9HK7nqnPPiBCb8JaUpS_EMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completevV40FU2zRERwtZPMrBy5HSWShVKwBXGykDta93lRBr8Meta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleI1BaFalATOLGsLIK1xXngs_eP5wK2cxuh1roprGU7IMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailKxHGXm4a176_45GD5gqvGeQCRcgL0cdLu1O16nj7nbeD8Meta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm_yzHlW9vReWQnjwM3sYYCmp37LBIH_k2Whvvjh0KQzsMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentwTYTStUSxbidsAnKZX1j_45ZB8MwEj4MQnZvuL08UZl8QMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmjD90aS_451yMBf0vYdykfhzx3Csa_9okyxhkcAtQ7_bDUMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeyzCVSP3CvxGfORP76Xpp2G2Wk3nphhY135Of0nU_AH4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeGOdRfjxnA6RlvWm80HL9IaVNMdabeTVyzLHUc0G_451gcMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordr3z6ZMXrz70Jjc1BXy1e6aOsVYn01HMrR4V_45z3BMUwUMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerL5sPfx1kRRkahxncS4HADtSWUw1vGcrUXpRmIfgBGbIMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45code4LWNvVaOG3faYr_r6Yd_45s47uFpAEpMIupxUXCSNok_QMeta || {},
    component: () => import("/codebuild/output/src3903864779/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3903864779/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]